export default __webpack_public_path__ + "assets/arrow.e7155927.svg";